import axios from "axios";

const validatorAPI = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}/analyzer/api/`,
  headers: {
    "Content-Type": "application/json",
  },
});

// Attach Authorization header
const setAuthHeader = () => {
  const token = localStorage.getItem("accessToken");
  if (token) {
    validatorAPI.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  }
};

export const fetchSavedPrompts = async () => {
  setAuthHeader();
  const response = await validatorAPI.get("prompts/");
  return response.data;
};

export const savePromptTemplate = async (promptData) => {
  setAuthHeader();
  const response = await validatorAPI.post("prompts/", promptData);
  return response.data;
};

export const deletePromptTemplate = async ({ name }) => {
  setAuthHeader();
  const response = await validatorAPI.delete("prompts/", {
    data: { name },
  });
  return response.data;
};

export const fetchLogs = async () => {
  setAuthHeader();
  const response = await validatorAPI.get("logs/");
  return response.data;
};

export const runValidatorAnalysis = async (formData) => {
  setAuthHeader();
  const response = await validatorAPI.post("upload/", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};
